import { FontCategory } from '@quicktools/shared-components/data/fonts';
import IconLensFlare from '@picsart/icons/IconLensFlare';
import IconBrilliant from '@picsart/icons/IconBrilliant';
import IconItalic from '@picsart/icons/IconItalic';
import IconCapitalize from '@picsart/icons/IconCapitalize';
import IconBold from '@picsart/icons/IconBold';
import IconFlashOn from '@picsart/icons/IconFlashOn';
import IconLetterSpacing from '@picsart/icons/IconLetterSpacing';
import IconDuration from '@picsart/icons/IconDuration';
import IconText from '@picsart/icons/IconText';
import IconStarOutline from '@picsart/icons/IconStarOutline';
import IconFonts from '@picsart/icons/IconFonts';
import IconEmbedCode from '@picsart/icons/IconEmbedCode';
import IconArtisticBrushes from '@picsart/icons/IconArtisticBrushes';

import { Category } from '../types';

export const defaultText = 'Type something to start';

export const RECENT_CATEGORY: Category = {
  text: 'Recent',
  href: '/recent',
  pageName: 'recent',
  Icon: IconDuration,
  order: 0,
  id: FontCategory.Recents,
};

export const CATEGORIES: { [key: number]: Category } = {
  [FontCategory.All]: {
    text: 'All',
    headingText: 'All Fonts',
    href: '/',
    pageName: 'main',
    Icon: null,
    order: 1,
    id: FontCategory.All,
  },
  [FontCategory.Cool]: {
    text: 'Cool',
    href: '/cool',
    pageName: 'cool',
    Icon: IconLensFlare,
    order: 2,
    id: FontCategory.Cool,
  },
  [FontCategory.Fancy]: {
    text: 'Fancy',
    href: '/fancy',
    pageName: 'fancy',
    Icon: IconBrilliant,
    order: 3,
    id: FontCategory.Fancy,
  },
  [FontCategory.Cursive]: {
    text: 'Cursive',
    href: '/cursive',
    pageName: 'cursive',
    Icon: IconItalic,
    id: FontCategory.Cursive,
    order: 4,
  },
  [FontCategory.Small]: {
    text: 'Small',
    href: '/small',
    pageName: 'small',
    Icon: IconCapitalize,
    id: FontCategory.Small,
    order: 5,
  },
  [FontCategory.Basic]: {
    text: 'Basic',
    href: '/basic',
    pageName: 'basic',
    Icon: IconLetterSpacing,
    id: FontCategory.Basic,
    order: 6,
  },
  [FontCategory.Bold]: {
    text: 'Bold',
    href: '/bold',
    pageName: 'bold',
    Icon: IconBold,
    id: FontCategory.Bold,
    order: 7,
  },
  [FontCategory.Glitch]: {
    text: 'Glitch',
    href: '/glitch',
    pageName: 'glitch',
    Icon: IconFlashOn,
    id: FontCategory.Glitch,
    order: 8,
  },
  [FontCategory.Wrappers]: {
    text: 'Wrappers',
    href: '/wrappers',
    pageName: 'wrappers',
    Icon: IconText,
    id: FontCategory.Wrappers,
    order: 9,
  },
  [FontCategory.Lettercases]: {
    text: 'Letter cases',
    href: '/case-converter',
    pageName: 'letter_case',
    Icon: IconFonts,
    id: FontCategory.Lettercases,
    order: 10,
  },
  [FontCategory.Codes]: {
    text: 'Codes',
    href: '/codes',
    pageName: 'codes',
    Icon: IconEmbedCode,
    id: FontCategory.Codes,
    order: 11,
  },
  [FontCategory.SymbolText]: {
    text: 'Symbol text',
    href: '/symbols',
    pageName: 'symbols',
    Icon: IconStarOutline,
    id: FontCategory.SymbolText,
    order: 12,
  },
  [FontCategory.TextArt]: {
    text: 'Text art',
    href: '/text-art',
    pageName: 'text_art',
    Icon: IconArtisticBrushes,
    id: FontCategory.TextArt,
    order: 13,
  },
};
